import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { FeatureSettingsService } from 'src/app/services/feature-settings/feature-settings.service';

/** Intervalle de vérification de la fin de maintenance. */
export const MAINTENANCE_POLL_INTERVAL_MS = 60_000;

/**
 * Écran de maintenance du site client, activé depuis l'administration vendeur
 * (Fonctionnalités > Site client). Tant qu'il est affiché, il vérifie régulièrement si la
 * maintenance est levée et recharge alors le site.
 */
@Component({
  selector: 'ng-casto-maintenance',
  standalone: true,
  imports: [TranslateModule],
  templateUrl: './maintenance.component.html',
  styleUrl: './maintenance.component.scss',
})
export class MaintenanceComponent implements OnInit, OnDestroy {
  private timer?: ReturnType<typeof setInterval>;

  constructor(
    private readonly featureSettingsService: FeatureSettingsService,
    @Inject(DOCUMENT) private readonly document: Document
  ) {}

  ngOnInit(): void {
    this.timer = setInterval(() => this.checkMaintenanceEnded(), MAINTENANCE_POLL_INTERVAL_MS);
  }

  ngOnDestroy(): void {
    clearInterval(this.timer);
  }

  async checkMaintenanceEnded(): Promise<void> {
    // `undefined` (API injoignable) : on reste en maintenance.
    if ((await this.featureSettingsService.fetchCustomerMaintenance()) === false) {
      this.document.location.reload();
    }
  }
}
